import React from "react";

import FormattedNumberInput, { TextInputProps } from "../FormattedNumberInput";

const placesAfterDecimal = 3;

export const formValueToEditableValue = (value: string | number): string => {
  const num = Number(value);
  return num === 0 ? "0" : (num * 100).toFixed(placesAfterDecimal);
};

export const formValueToDisplayValue = (
  value: string | number,
  suffix: string | undefined,
): string => `${formValueToEditableValue(value)}%${suffix || ""}`;

export const editableValueToFormValue = (value: string | number): string => {
  const num = Number(value);
  return num === 0 ? "0" : (num / 100).toFixed(placesAfterDecimal + 2);
};

export interface PercentageInputProps extends TextInputProps {
  suffix?: string;
}

const PercentageInput = (props: PercentageInputProps) => {
  const { suffix, ...textInputProps } = props;

  return (
    <FormattedNumberInput
      formValueToDisplayValue={value => formValueToDisplayValue(value, suffix)}
      formValueToEditableValue={formValueToEditableValue}
      editableValueToFormValue={editableValueToFormValue}
      {...textInputProps}
    />
  );
};

export default PercentageInput;
